import React from "react";
import RegistrationNew from "./RegistrationNew";

const RegistrationIndex = () => {
  return <RegistrationNew />;
};

export default RegistrationIndex;
